import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map, combineLatestWith } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { combineLatest, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LandingPageGuard {
  constructor(private store: Store<fromStore.LandingState>, private router: Router, private route: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkStore(route).pipe(
      switchMap(a => of(a)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(fromRoot.getRouterState),
      this.store.select(fromStore.getSelectedLandingPage),
      this.store.select(fromStore.getSelectedLandingPageLoading),
      this.store.select(fromStore.getSelectedLandingPageLoaded),
      this.store.select(fromStore.getLandingPageError),
    ]).pipe(
      tap(([router, page, loading, loaded, error]) => {
        if (!loaded && !loading && !page) {
          const slug = router.state.params['slug'] || router.state.data['slug'];
          this.store.dispatch(fromStore.LoadLandingPageBySlug({ slug }));
        }

        // if (!loading && !page && error) {
        //   console.warn(error);
        //   this.router.navigate(['/', error.status === 404 ? '404' : '500'], { skipLocationChange: true });
        // }
      }),
      filter(([router, page, loading, loaded]) => loaded),
      map(([router, page, loading, loaded]) => {
        const slug = (router.state.params['slug'] || router.state.data['slug']).toLowerCase();

        if (page.slug !== slug) {
          let url = ['/', page.slug];

          const newUrl = this.router.createUrlTree(url, {
            relativeTo: this.route,
            queryParams: route.queryParams,
          });
          return newUrl;
        }
        return loaded;
      }),
      take(1)
    );
  }
}
